package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.FlagW500Rounded: ImageVector
    get() {
        if (_flagW500Rounded != null) {
            return _flagW500Rounded!!
        }
        _flagW500Rounded = Builder(name = "FlagW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(282.87f, 568.13f)
                verticalLineToRelative(234.5f)
                quadToRelative(0.0f, 19.15f, -13.17f, 32.33f)
                quadToRelative(-13.18f, 13.17f, -32.33f, 13.17f)
                reflectiveQuadToRelative(-32.33f, -13.17f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                verticalLineToRelative(-605.26f)
                quadToRelative(0.0f, -19.15f, 13.17f, -32.33f)
                quadToRelative(13.18f, -13.17f, 32.33f, -13.17f)
                horizontalLineToRelative(291.78f)
                quadToRelative(16.15f, 0.0f, 28.59f, 10.31f)
                quadToRelative(12.43f, 10.32f, 15.91f, 26.23f)
                lineToRelative(9.05f, 43.46f)
                horizontalLineToRelative(179.93f)
                quadToRelative(19.15f, 0.0f, 32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                verticalLineToRelative(325.26f)
                quadToRelative(0.0f, 19.15f, -13.17f, 32.33f)
                quadToRelative(-13.18f, 13.17f, -32.33f, 13.17f)
                lineTo(550.85f, 648.13f)
                quadToRelative(-16.15f, 0.0f, -28.59f, -10.31f)
                quadToRelative(-12.43f, -10.32f, -15.91f, -26.23f)
                lineToRelative(-9.05f, -43.46f)
                lineTo(282.87f, 568.13f)
                close()
                moveTo(588.63f, 557.13f)
                horizontalLineToRelative(128.5f)
                verticalLineToRelative(-234.26f)
                lineTo(544.91f, 322.87f)
                quadToRelative(-16.15f, 0.0f, -28.58f, -10.32f)
                quadToRelative(-12.44f, -10.31f, -15.92f, -26.22f)
                lineToRelative(-9.04f, -43.46f)
                horizontalLineToRelative(-208.5f)
                verticalLineToRelative(234.26f)
                horizontalLineToRelative(252.22f)
                quadToRelative(16.15f, 0.0f, 28.58f, 10.32f)
                quadToRelative(12.44f, 10.31f, 15.92f, 26.22f)
                lineToRelative(9.04f, 43.46f)
                close()
                moveTo(500.0f, 400.0f)
                close()
            }
        }
        .build()
        return _flagW500Rounded!!
    }

private var _flagW500Rounded: ImageVector? = null
